import * as ds from '@zedelivery/mozeic-style-dictionary/js'

const theme = {
  ds,
  Space0X: ds.Space0X,
  Space1X: ds.Space1X,
  Space2X: ds.Space2X,
  Space3X: ds.Space3X,
  Space4X: ds.Space4X,
  Space5X: ds.Space5X,
  Space6X: ds.Space6X,
  Space7X: '56px',
  Space8X: '64px',
  Space9X: '72px',
  Space10X: '80px',
}

type Theme = typeof theme

export type { Theme }

export type ThemeProp = {
  theme: Theme
}

export default theme
